import { AbstractCommand } from 'src/models/command';

class DeleteTheIdoContactPersonCommand extends AbstractCommand {
	readonly name = 'IFS_IDO_Command_Command_DeleteTheIdoContactPersonCommand';

	public constructor(idoId: string, idoInstanceId: string, contactPersonId: string) {
		super();
		this.parameters = {
			contactPersonId: contactPersonId,
			idoId: idoId,
			idoInstanceId: idoInstanceId,
		};
	}
}

export { DeleteTheIdoContactPersonCommand };
